import { matchPath } from 'react-router-dom'

/** Only these routes use local synthetic data and must never mount live services. */
export function isLocalFixturePath(pathname: string): boolean {
  return ['/vault/crew-day', '/vault/crew-field', '/vault/ads', '/vault/inspections', '/vault/hub-payments', '/vault/payments-list', '/vault/punch-list', '/vault/review-ask', '/vault/growth', '/__design/growth', '/vault/materials-log', '/vault/mail'].some(path => matchPath(path, pathname) !== null)
}
